import { useContext, useEffect, useMemo, useState } from "react";
import { Button, Card, CardBody, Modal, ModalBody, Table } from "reactstrap";

import ordemServicoService from "services/OrdemServicoService";
import Imagem from "components/Imagem";
import { StatusDivergenciaEnum } from "services/OrdemServicoService";
import { StatusCorrecaoEnum } from "services/OrdemServicoService";
import { confirm } from "components/Confirmation";
import { toast } from "react-toastify";
import ModalArquivo from "../../../../components/ModalArquivo";
import arquivoService from "services/ArquivoService";
import { erroInesperado } from "services/Utils";
import ModalIncluirEvidencia from "../Movimentacoes/ModalIncluirEvidencia";
import ModalAlterarMovimentacao from "./ModalAlterarMovimentacao";
import ModalAlterarGarantia from "./ModalAlterarGarantia";
import AppContext from "AppContext";
import { StatusOrdemServicoEnum } from "services/OrdemServicoService";
import { showLoading } from "components/Loading";
import { hideLoading } from "components/Loading";
import { adicionarApiUrl } from "services/Utils";
import { TipoContratoEnum } from "services/ContratoService";

export default function ModalDetalhes({ config, onClosed }) {
  const [item, setItem] = useState()
  const [configModalArquivo, setConfigModalArquivo] = useState()
  const [configModalIncluirEvidencia, setConfigModalIncluirEvidencia] = useState()
  const [configModalAlterarMovimentacao, setConfigModalAlterarMovimentacao] = useState()
  const [configModalAlterarGarantia, setConfigModalAlterarGarantia] = useState()
  const { state } = useContext(AppContext)

  const podeAlterarEvidencias = useMemo(() => {
    if (!config || !config.os.empresaExecutora || !(state?.user?.acoes || []).includes('os.gerenciar'))
      return false
    return config.os.empresaExecutora.id == state.user.empresa.id &&
      [StatusOrdemServicoEnum.EM_FASE_EXECUCAO, StatusOrdemServicoEnum.AGUARDANDO_CONFERENCIA_EXECUCAO].includes(config.os.idStatus)
  }, [config, state.user])

  const tipoContrato = config?.os?.contrato_tipoContrato

  const carregar = () => {
    if (config) {
      ordemServicoService.getItemById(config.idOrdemServico, config.idItem).then(res => {
        if (res.success) {
          setItem(res.data)
        } else {
          setItem()
          toast("Erro ao carregar detalhes do item")
        }
      }).catch(() => {
        setItem()
        toast("Erro ao carregar detalhes do item")
      })
    } else {
      setItem()
    }
  }

  useEffect(() => {
    carregar()
  }, [config])

  const handleDeleteFotoItem = (id, idMovimentacao) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = idMovimentacao
            ? await ordemServicoService.excluirFotoMovimentacao(config.idOrdemServico, config.idItem, idMovimentacao, id)
            : await ordemServicoService.excluirFotoItem(config.idOrdemServico, config.idItem, id)
          if (res.success) {
            carregar()
            toast("Evidência excluída")
          } else {
            toast("Erro ao excluir evidência")
          }
        } catch (ex) {
          toast("Erro ao excluir evidência")
        }
      }
    })
  }

  const handleEditFotoItemAntes = (id, idMovimentacao) => {
    setConfigModalArquivo({
      title: 'Selecione uma nova foto da área antes da execução',
      onFileSelected: async (file) => {
        try {
          showLoading()
          let idArquivo
          const res = await arquivoService.upload(file)
          if (res.success) {
            idArquivo = res.data
          } else {
            hideLoading()
            toast('Erro ao enviar arquivo')
            return
          }

          if (idMovimentacao) {
            await ordemServicoService.alterarFotoMovimentacaoAntes(config.idOrdemServico, config.idItem, idMovimentacao, id, idArquivo)
          } else {
            await ordemServicoService.alterarItemFotoAntes(config.idOrdemServico, config.idItem, id, idArquivo)
          }
          hideLoading()
          toast('Registro salvo com sucesso!')
          carregar()
        } catch (ex) {
          hideLoading()
          erroInesperado()
        }
      }
    })
  }

  const handleEditFotoItemDepois = (id, idMovimentacao) => {
    setConfigModalArquivo({
      title: 'Selecione uma nova foto da área depois da execução',
      onFileSelected: async (file) => {
        try {
          showLoading()
          let idArquivo
          const res = await arquivoService.upload(file)
          if (res.success) {
            idArquivo = res.data
          } else {
            hideLoading()
            toast('Erro ao enviar arquivo')
            return
          }

          if (idMovimentacao) {
            await ordemServicoService.alterarFotoMovimentacaoDepois(config.idOrdemServico, config.idItem, idMovimentacao, id, idArquivo)
          } else {
            await ordemServicoService.alterarItemFotoDepois(config.idOrdemServico, config.idItem, id, idArquivo)
          }
          hideLoading()
          toast('Registro salvo com sucesso!')
          carregar()
        } catch (ex) {
          erroInesperado()
        }
      }
    })
  }

  const handleAdicionarEvidencias = (idMovimentacao) => {
    setConfigModalIncluirEvidencia({
      onFileSelected: async (arquivoAntes, arquivoDepois) => {
        try {
          let idArquivoAntes, idArquivoDepois
          showLoading()
          const resAntes = await arquivoService.upload(arquivoAntes)
          if (resAntes.success) {
            idArquivoAntes = resAntes.data
          } else {
            hideLoading()
            toast('Erro ao enviar arquivo')
            return
          }

          const resDepois = await arquivoService.upload(arquivoDepois)
          if (resDepois.success) {
            idArquivoDepois = resDepois.data
          } else {
            hideLoading()
            toast('Erro ao enviar arquivo')
            return
          }

          if (idMovimentacao) {
            await ordemServicoService.incluirFotoMovimentacao(config.idOrdemServico, config.idItem, idMovimentacao, idArquivoAntes, idArquivoDepois)
          } else {
            await ordemServicoService.incluirItemFoto(config.idOrdemServico, config.idItem, idArquivoAntes, idArquivoDepois)
          }
          hideLoading()
          toast('Registro salvo com sucesso!')
          carregar()
        } catch (ex) {
          hideLoading()
          erroInesperado()
        }
      }
    })
  }

  const handleAdicionarFotoRefletancia = () => {
    setConfigModalArquivo({
      title: 'Selecione uma foto de refletância',
      onFileSelected: async (file) => {
        try {
          showLoading()
          const res = await arquivoService.upload(file)
          if (!res.success) {
            hideLoading()
            toast('Erro ao enviar arquivo')
            return
          }

          await ordemServicoService.incluirFotoRefletancia(config.idOrdemServico, config.idItem, res.data)
          hideLoading()
          toast('Registro salvo com sucesso!')
          carregar()
        } catch (ex) {
          hideLoading()
          erroInesperado()
        }
      }
    })
  }

  const handleDeleteFotoRefletancia = (id) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await ordemServicoService.excluirFotoRefletancia(config.idOrdemServico, config.idItem, id)
          if (res.success) {
            carregar()
            toast("Foto de refletância excluída")
          } else {
            toast("Erro ao excluir foto de refletância")
          }
        } catch (ex) {
          toast("Erro ao excluir foto de refletância")
        }
      }
    })
  }

  const handleAlterarQuantidadeExecutada = () => {
    setConfigModalAlterarMovimentacao({
      idOrdemServico: config.idOrdemServico,
      idItem: config.idItem,
      quantidadeExecutadoFmt: item.quantidadeExecutadoFmt,
      onChanged: () => {
        carregar()
      }
    })
  }

  const handleEditarGarantia = (movimentacao) => {
    setConfigModalAlterarGarantia({
      idOrdemServico: config.idOrdemServico,
      idItem: config.idItem,
      idMovimentacao: movimentacao.id,
      prazoGarantiaMeses: movimentacao.componenteInstalado.prazoGarantiaMeses,
      onChanged: () => {
        carregar()
      }
    })
  }

  return (
    <>
      <Modal isOpen={!!config} size="xl" toggle={() => onClosed && onClosed()}>
        <ModalBody>
          {(config && item) && (
            <>
              <h2>Detalhes do Item</h2>
              <hr />
              <div className="text-dark">
                {item.codigo} - {item.descricao}
              </div>
              <Table className="mt-4">
                <thead>
                  <tr>
                    <th></th>
                    <th>Quant.</th>
                    <th>Valor Unit.</th>
                    <th>Valor Total</th>
                  </tr>
                </thead>
                <tbody>
                  {tipoContrato == TipoContratoEnum.NORMAL && (
                    <tr>
                      <td>Prevista</td>
                      <td>{item.quantidadeFmt} {item.unidade}</td>
                      <td>R$ {item.precoUnitarioFmt}</td>
                      <td>R$ {item.precoTotalFmt}</td>
                    </tr>
                  )}
                  <tr>
                    <td className="align-middle">Executada</td>
                    <td>
                      <div className="d-flex flex-row justify-content-between align-items-center">
                        <span>{item.quantidadeExecutadoFmt} {item.unidade}</span>
                        {(podeAlterarEvidencias && tipoContrato == TipoContratoEnum.NORMAL) && (
                          <Button color="primary" size="sm" onClick={handleAlterarQuantidadeExecutada}>Alterar</Button>
                        )}
                      </div>
                    </td>
                    <td className="align-middle">R$ {item.precoUnitarioFmt}</td>
                    <td className="align-middle">R$ {item.precoTotalExecutadoFmt}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={3} className="text-right"><strong>Saldo de Custo</strong></td>
                    <td>R$ {item.saldoCustoFmt}</td>
                  </tr>
                </tfoot>
              </Table>
              {tipoContrato == TipoContratoEnum.NORMAL && (
                <>
                  <Evidencias
                    fotos={item.fotos}
                    fotosRefletancia={item.fotosRefletancia}
                    podeAlterarEvidencias={podeAlterarEvidencias}
                    handleAdicionarEvidencias={handleAdicionarEvidencias}
                    handleEditFotoItemAntes={handleEditFotoItemAntes}
                    handleEditFotoItemDepois={handleEditFotoItemDepois}
                    handleDeleteFotoItem={handleDeleteFotoItem}
                    handleAdicionarFotoRefletancia={handleAdicionarFotoRefletancia}
                    handleDeleteFotoRefletancia={handleDeleteFotoRefletancia}
                  />
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginTop: 16 }}>
                    {item.divergencias.map(divergencia => (
                      <RegistroDivergencia key={divergencia.id} item={divergencia} />
                    ))}
                  </div>
                </>
              )}

              {tipoContrato == TipoContratoEnum.SEMAFORICO && (
                <>
                  <div className="d-flex flex-row justify-content-between align-items-center mb-2">
                    <h2 className="m-0">Movimentações</h2>
                  </div>
                  <div className="d-flex flex-column" style={{ rowGap: 16 }}>
                    {item?.movimentacoes?.map(el => (
                      <Card key={el.id}>
                        <CardBody>
                          {el.dataFmt} - {el.tipoFmt}
                          <p>
                            {(el.componenteRemovido && el.componenteInstalado) ? (
                              <>
                                {el.componenteRemovido.qrCode} ({el.componenteRemovido.tipoComponente}) - {el.componenteRemovido.modelo} → {el.componenteInstalado.qrCode} ({el.componenteInstalado.tipoComponente}) - {el.componenteInstalado.modelo}
                              </>
                            ) : el.componenteRemovido ? (
                              <>
                                {el.componenteRemovido.qrCode} ({el.componenteRemovido.tipoComponente}) - {el.componenteRemovido.modelo}
                              </>
                            ) : el.componenteInstalado ? (
                              <>
                                {el.componenteInstalado.qrCode} ({el.componenteInstalado.tipoComponente}) - {el.componenteInstalado.modelo}
                              </>
                            ) : null}
                          </p>
                          {el.componenteInstalado && (
                            <p className="d-flex align-items-center" style={{ gap: 8 }}>
                              Garantia: {el.componenteInstalado.prazoGarantiaMeses} meses (até {el.componenteInstalado.dataFimGarantiaFmt})
                              {podeAlterarEvidencias && (
                                <Button size="sm" color="link" onClick={() => handleEditarGarantia(el)}>Editar</Button>
                              )}
                            </p>
                          )}
                          <Evidencias
                            fotos={el.fotos}
                            idMovimentacao={el.id}
                            podeAlterarEvidencias={podeAlterarEvidencias}
                            handleAdicionarEvidencias={handleAdicionarEvidencias}
                            handleEditFotoItemAntes={handleEditFotoItemAntes}
                            handleEditFotoItemDepois={handleEditFotoItemDepois}
                            handleDeleteFotoItem={handleDeleteFotoItem}
                          />
                        </CardBody>
                      </Card>
                    ))}
                  </div>
                </>
              )}
              <hr />
              <div className="row mt-2">
                <div className="col-12 text-right">
                  <Button color="primary" onClick={onClosed} outline>Fechar</Button>
                </div>
              </div>
            </>
          )}
        </ModalBody>
      </Modal>
      <ModalArquivo config={configModalArquivo} onClosed={() => setConfigModalArquivo()} />
      <ModalIncluirEvidencia config={configModalIncluirEvidencia} onClosed={() => setConfigModalIncluirEvidencia()} />
      <ModalAlterarMovimentacao config={configModalAlterarMovimentacao} onClosed={() => setConfigModalAlterarMovimentacao()} />
      <ModalAlterarGarantia config={configModalAlterarGarantia} onClosed={() => setConfigModalAlterarGarantia()} />
    </>
  )
}

function RegistroDivergencia({ item }) {
  const { state } = useContext(AppContext)
  return (
    <div className="border rounded p-3 d-flex flex-column gap-10px shadow">
      <div className="d-flex justify-content-between">
        <div><strong>{item.usuario}</strong></div>
        <div>{item.dataFmt}</div>
      </div>
      <div>
        {item.observacao}
      </div>
      <div>
        <hr style={{ marginTop: 0, marginBottom: 0 }} />
        <div>
          <strong>Status:</strong> <span style={{ color: item.status == StatusDivergenciaEnum.APROVADA ? 'green' : 'red' }}>{item.statusFmt}</span>
        </div>
        <hr style={{ marginTop: 0, marginBottom: 0 }} />
      </div>
      <div className="d-flex gap-5px">
        {item.fotos.map(el => (
          <Imagem
            key={el.id}
            url={el.url}
            urlThumb={el.urlThumb}
            dadosLocalizacao={el.dadosLocalizacao}
            tituloModal="Divergência"
          />
        ))}
      </div>
      {item.correcoes.map(correcao => (
        <div className="p-2 rounded d-flex flex-column gap-5px" style={{ background: state.theme == 'dark' ? '#333' : '#f2f2f2' }} key={correcao.id}>
          <div className={"text-center rounded"} style={{ background: state.theme == 'dark' ? '#444' : '#e0e0e0' }}>Correção</div>
          <div className="d-flex flex-column gap-5px">
            <div className="d-flex justify-content-between">
              <div><strong>{correcao.usuario}</strong></div>
              <div>{correcao.dataFmt}</div>
            </div>
            <div>{correcao.observacao}</div>
            <div>
              <hr style={{ marginTop: 0, marginBottom: 0 }} />
              {correcao.status != StatusCorrecaoEnum.PENDENTE && (
                <>
                  <div><strong>Status:</strong> <span style={{ color: correcao.status == StatusCorrecaoEnum.APROVADA ? 'green' : 'red' }}>{correcao.statusFmt}</span></div>
                  <div><strong>Fiscal:</strong> {correcao.fiscal}</div>
                  <div><strong>Data:</strong> {correcao.dataFiscalizacaoFmt}</div>
                  {correcao.status == StatusCorrecaoEnum.REPROVADA && (
                    <div><strong>Motivo:</strong> {correcao.motivoReprovacao}</div>
                  )}
                </>
              )}
              <hr style={{ marginTop: 0, marginBottom: 0 }} />
            </div>
            <div className="d-flex gap-5px">
              {correcao.fotos.map(el => (
                <Imagem
                  key={el.id}
                  url={el.url}
                  urlThumb={el.urlThumb}
                  dadosLocalizacao={el.dadosLocalizacao}
                  tituloModal="Divergência"
                />
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

function Evidencias({ fotos, fotosRefletancia, idMovimentacao, podeAlterarEvidencias, handleAdicionarEvidencias, handleEditFotoItemAntes, handleEditFotoItemDepois, handleDeleteFotoItem, handleAdicionarFotoRefletancia, handleDeleteFotoRefletancia }) {
  const { state } = useContext(AppContext)
  const [escolherTipoAberto, setEscolherTipoAberto] = useState(false)
  const permiteRefletancia = fotosRefletancia !== undefined

  const handleClickIncluir = () => {
    if (permiteRefletancia) {
      setEscolherTipoAberto(true)
    } else {
      handleAdicionarEvidencias(idMovimentacao)
    }
  }

  return (
    <>
      <div className="d-flex flex-row justify-content-between align-items-center mb-2">
        <h2 className="m-0">Evidências</h2>
        {podeAlterarEvidencias && (
          <Button color="primary" size="sm" onClick={handleClickIncluir}>{permiteRefletancia ? 'Incluir' : 'Adicionar'}</Button>
        )}
      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        gap: 16,
        flexWrap: 'wrap',
      }}>
        {fotos.map(el => (
          <div
            key={el.id}
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: 16,
              padding: 16,
              background: state.theme === 'dark' ? '#333' : '#f2f2f2',
              borderRadius: 8,
              position: "relative"
            }}
          >
            <div>
              Antes
              <Imagem
                url={el.urlAntes}
                urlThumb={el.urlAntesThumb}
                dadosLocalizacao={el.dadosLocalizacaoAntes}
                tituloModal="Antes"
                showEdit={podeAlterarEvidencias}
                onEdit={() => handleEditFotoItemAntes(el.id, idMovimentacao)}
              />
            </div>
            <div>
              Depois
              <Imagem
                url={el.urlDepois}
                urlThumb={el.urlDepoisThumb}
                dadosLocalizacao={el.dadosLocalizacaoDepois}
                tituloModal="Depois"
                showEdit={podeAlterarEvidencias}
                onEdit={() => handleEditFotoItemDepois(el.id, idMovimentacao)}
              />
            </div>
            {podeAlterarEvidencias && (
              <div style={{
                position: "absolute",
                width: 24,
                height: 24,
                padding: 2,
                display: "flex",
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 3,
                background:  state.theme === 'dark' ? '#333' : 'white',
                top: 3,
                right: 3,
                cursor: 'pointer'
              }} onClick={() => handleDeleteFotoItem(el.id, idMovimentacao)}>
                <i className="bi bi-trash-fill"></i>
              </div>
            )}
          </div>
        ))}
      </div>
      {permiteRefletancia && (
        <>
          <h2 className="mt-4 mb-2">Refletância</h2>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 16,
            flexWrap: 'wrap',
          }}>
            {fotosRefletancia.map(el => (
              <div key={el.id} style={{ position: "relative" }}>
                <Imagem
                  url={el.url}
                  urlThumb={el.urlThumb}
                  dadosLocalizacao={el.dadosLocalizacao}
                  tituloModal="Refletância"
                />
                {podeAlterarEvidencias && (
                  <div style={{
                    position: "absolute",
                    width: 24,
                    height: 24,
                    padding: 2,
                    display: "flex",
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 3,
                    background: state.theme === 'dark' ? '#333' : 'white',
                    top: 3,
                    right: 3,
                    cursor: 'pointer'
                  }} onClick={() => handleDeleteFotoRefletancia(el.id)}>
                    <i className="bi bi-trash-fill"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
      <Modal isOpen={escolherTipoAberto} toggle={() => setEscolherTipoAberto(false)}>
        <ModalBody>
          <h2>Incluir foto</h2>
          <hr />
          <p>Selecione o tipo de foto que deseja incluir:</p>
          <div className="d-flex flex-row gap-10px justify-content-end">
            <Button color="primary" outline onClick={() => setEscolherTipoAberto(false)}>Cancelar</Button>
            <Button color="primary" onClick={() => { setEscolherTipoAberto(false); handleAdicionarFotoRefletancia() }}>Refletância</Button>
            <Button color="primary" onClick={() => { setEscolherTipoAberto(false); handleAdicionarEvidencias(idMovimentacao) }}>Evidência</Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}
